var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-container"},[_c('el-breadcrumb',{attrs:{"separato":"/"}},[_c('el-breadcrumb-item',{staticClass:"el-icon-arrow-left"},[_c('span',{on:{"click":_vm.back}},[_vm._v("返回")])]),_c('el-breadcrumb-item',[_vm._v("媒体报道")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }